const state = {
  delay: 500
}

export default {
  namespaced: true,
  state
}
